// extracted by mini-css-extract-plugin
export default {"header":"wVM0dnSU5P3Fc8I","header-content":"QFE1MyIkR2WRNqv","grid":"Eyqubqj2URHRc69","special-offer":"os93LmJKb5q7dQ7"};